module.exports = __webpack_public_path__ + "media/images/main-logo-blue-67e45b19b146dc00d2a6fd9a31907df9.svg";